// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3l9kD","inner":"Footer_inner__WZ4r6","nextIcon":"Footer_nextIcon__35jVC","innerLeft":"Footer_innerLeft__1Voqb"};